const insetShadow = "box-shadow: inset rgba(0, 0, 0, 0.2) 0 1px 5px;";
const insetShadow2 = "box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.25);";
const subtleShadow = "box-shadow: rgba(0, 0, 0, 0.08) 1px 1px 3px;";
const accentShadow = "box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 4px;";
const buttonShadow = "filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));";
const selectListShadow = "box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.25);";
const defaultShadow = "box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.3);";
const deepShadow = "box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.6);";
const noShadow = "box-shadow: rgba(0, 0, 0, 0) 1px 1px 1px;";
const textShadow = "text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;";

export {
  insetShadow,
  insetShadow2,
  subtleShadow,
  buttonShadow,
  selectListShadow,
  defaultShadow,
  deepShadow,
  accentShadow,
  noShadow,
  textShadow,
};
